import { render, staticRenderFns } from "./OverviewCard.vue?vue&type=template&id=3b99f50a&scoped=true"
import script from "./OverviewCard.vue?vue&type=script&lang=js"
export * from "./OverviewCard.vue?vue&type=script&lang=js"
import style0 from "./OverviewCard.vue?vue&type=style&index=0&id=3b99f50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b99f50a",
  null
  
)

export default component.exports